import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  slug: string;
  thumbnail: string;
  duration: string;
  category: string;
  categorySlug: string;
  views: string;
  rating: string;
  isHot?: boolean;
  isNew?: boolean;
}

export default function VideoCard({
  title,
  slug,
  thumbnail,
  duration,
  category,
  categorySlug,
  views,
  rating,
  isHot,
  isNew,
}: VideoCardProps) {
  return (
    <Link to={`/article/${slug}`} className="group block">
      <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200">
        <img
          src={thumbnail}
          alt={title}
          title={`${title} - 91视频在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        {isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-background-50 whitespace-nowrap">
            热门
          </span>
        )}
        {isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-background-50 whitespace-nowrap">
            新上
          </span>
        )}
        {isHot && isNew && (
          <>
            <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-background-50 whitespace-nowrap">热门</span>
            <span className="absolute top-8 left-2 px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-background-50 whitespace-nowrap">新上</span>
          </>
        )}

        <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium rounded bg-black/70 text-background-50 whitespace-nowrap">
          {duration}
        </span>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
          {title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5">
          <Link
            to={`/category/${categorySlug}`}
            className="text-xs text-secondary-600 hover:text-secondary-700 bg-secondary-100 px-2 py-0.5 rounded whitespace-nowrap"
            onClick={(e) => e.stopPropagation()}
          >
            {category}
          </Link>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-eye-line text-xs"></i>
            {views}
          </span>
          <span className="text-xs text-accent-600 flex items-center gap-1">
            <i className="ri-star-fill text-xs"></i>
            {rating}
          </span>
        </div>
      </div>
    </Link>
  );
}